import TextFieldComponent from '../textfield';

class TextAreaComponent extends TextFieldComponent {
  constructor (component, data, options) {
    super(component, data, options);
  }
}

export default TextAreaComponent;
